import { Link } from 'react-router-dom';
import { useState } from 'react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletter = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const res = await fetch(`${BACKEND_URL}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      toast.success(data.message);
      setEmail('');
    } catch {
      toast.error('Error al suscribirse');
    }
  };

  return (
    <footer className="bg-[#050505] border-t border-white/5" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-xl font-bold tracking-tighter mb-4" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
              ELITE GOLF <span className="text-zinc-600">MX</span>
            </h3>
            <p className="text-sm text-zinc-500 leading-relaxed">
              Lujo, precision y estilo de vida en cada swing.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold mb-4">Navegacion</p>
            <div className="space-y-3">
              {[['/', 'Inicio'], ['/experiencias', 'Experiencias'], ['/nosotros', 'Nosotros'], ['/contacto', 'Concierge']].map(([href, label]) => (
                <Link key={href} to={href} className="block text-sm text-zinc-400 hover:text-white transition-colors">{label}</Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold mb-4">Contacto</p>
            <div className="space-y-3 text-sm text-zinc-400">
              <p>info@elitegolfmx.mx</p>
              <a href="https://wa.me/524442049874" target="_blank" rel="noreferrer" className="block hover:text-white transition-colors">
                +52 444 204 9874
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold mb-4">Newsletter</p>
            <p className="text-sm text-zinc-500 mb-4">Recibe ofertas exclusivas y novedades.</p>
            <form onSubmit={handleNewsletter} className="flex" data-testid="newsletter-form">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="tu@email.com"
                className="flex-1 bg-white/5 border border-white/10 px-4 py-2.5 text-sm text-white placeholder:text-zinc-600 focus:outline-none focus:border-white/30"
                data-testid="newsletter-email-input"
              />
              <button type="submit" className="bg-white text-black px-4 py-2.5 text-sm font-medium hover:bg-zinc-200 transition-colors" data-testid="newsletter-submit">
                Suscribir
              </button>
            </form>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 text-center">
          <p className="text-xs text-zinc-600">&copy; {new Date().getFullYear()} Elite Golf MX. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
